import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { imgSrc } from "@/lib/api";

export const ProductCard = ({ product, index }) => (
  <motion.div layout initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}
    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: (index % 3) * 0.06 }}>
    <Link to={`/products/${product.slug}`} data-testid={`product-card-${product.slug}`} className="group block">
      <div className="spec-frame relative aspect-[4/5] overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_45%,rgba(255,196,0,0.35),transparent_60%)] opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
        <img src={imgSrc(product.image)} alt={product.name} loading="lazy"
          className="absolute inset-[12%] h-[76%] w-[76%] object-contain transition-transform duration-700 ease-out group-hover:scale-[1.06]" />
        <span className="absolute left-4 top-4 font-mono text-xs text-zinc-700">{String(index + 1).padStart(2, "0")}</span>
        {product.isNew && <span className="absolute right-4 top-4 bg-[#FFC400] px-2 py-1 font-mono text-[11px] font-medium uppercase tracking-wider text-[#0B0B0B]">New</span>}
        <span className="absolute bottom-0 left-0 h-1 w-0 bg-[#FF5A00] transition-[width] duration-700 group-hover:w-full" />
      </div>
      <div className="mt-4 flex items-start justify-between gap-4">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-600">{product.category}</p>
          <h3 className="font-wide mt-1.5 text-lg font-bold leading-tight tracking-tight">{product.name}</h3>
          <p className="mt-2 font-mono text-xs text-zinc-700">MOQ 100 kg</p>
        </div>
        <ArrowUpRight className="mt-1 h-5 w-5 shrink-0 transition-transform duration-500 group-hover:rotate-45 group-hover:text-[#FF5A00]" />
      </div>
    </Link>
  </motion.div>
);
